// Conversation tones: a short, soft "pop" when you send a message (like
// WhatsApp's), synthesized — no audio file to fetch. On by default; the
// switch (Appearance → Sounds) is per device.
const KEY = "xmm.sounds";

export function soundsOn(): boolean {
  try {
    return localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
}
export function setSounds(on: boolean) {
  try {
    localStorage.setItem(KEY, on ? "on" : "off");
  } catch {
    /* storage blocked */
  }
}

let ctx: AudioContext | null = null;
let last = 0;

/** A message left this device (a burst — forwarding to many — plays once). */
export function playSent() {
  if (!soundsOn() || Date.now() - last < 250) return;
  last = Date.now();
  const w = window as unknown as { __xmmSentSounds?: number };
  w.__xmmSentSounds = (w.__xmmSentSounds ?? 0) + 1; // (tests count them)
  try {
    ctx ??= new AudioContext();
    void ctx.resume();
    const t = ctx.currentTime;
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    o.type = "sine";
    // A quick upward sweep with a fast fade: a soft "pop".
    o.frequency.setValueAtTime(520, t);
    o.frequency.exponentialRampToValueAtTime(980, t + 0.07);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.09, t + 0.012);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.13);
    o.connect(g).connect(ctx.destination);
    o.start(t);
    o.stop(t + 0.14);
  } catch {
    /* no audio */
  }
}
